<template>
    <div class="container">
        <section class="confirm-page">
            <img class="confirm-page__icon confirm-page__icon--smartphone" :src="imgSrc" loading="lazy" alt="">
            <h2 class="confirm-page__title confirm-page__title--no-info">
                Super <span>{{ formattedFirstName }}</span> !<br />
                <span v-text="callbackText"></span>
            </h2>
        </section>
    </div>
</template>
<script>
import collapseTransition from "@ivanv/vue-collapse-transition";

export default {
    name: "AppointmentAsked",
    components: {
        'collapse-transition': collapseTransition,
    },
    props: {
        step : String,
        imgSrc : String,
        firstName : {
            type : String,
            default: ''
        },
        storeWithoutAppointment : {
            type: String,
            default: ''
        },
        storeChoose : {
            type: String,
            default: ''
        }
    },
    computed : {
        formattedFirstName() {
            if (!this.firstName) {
                return '';
            }
            const lower = this.firstName.trim().toLowerCase();
            return lower.charAt(0).toUpperCase() + lower.slice(1);
        },
        callbackText(){
            return this.storeChoose === this.storeWithoutAppointment ? 'On vous rappelle dès l’ouverture du magasin.' : 'On vous rappelle rapidement.';
        }
    },
    watch: {
        step(newStep) {
            if (newStep === 'APPOINTMENT_ASKED') {
                this.$nextTick(() => {
                    this.onVisible();
                });
            }
        }
    },
    methods :{
        onVisible(){
            document.querySelector('.bloc-left').style.display = 'none';
            this.addDataLayer()
        },
        addDataLayer(){
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                "event": "custom_event",
                "atEvent": "callback.confirmation",
                "leadType": "callback",
                "goalType": "callback",
                "category": "callback",
                "action" : "confirmation",
                "label" : ""
            });
            console.info("[GTM] Following data was added to dataLayer:")
            console.table(dataLayer)
        }
    }
}
</script>

<style scoped>

</style>
